<div class="row">
  <div class="col-12 col-xl-12 mb-4 mb-xl-0 ">
    <div class="card-body">
      <!-- <h2 class="card-title">Programme</h2> -->
      <!-- <p class="card-description">List Pr</p> -->
      <div class="col-sm-12">
        <label class="col-form-label">Cohort Name</label>
        <div class="row">
          <dx-select-box class="col-sm-11" [dataSource]="programList" [grouped]="true" valueExpr="cohort_id" displayExpr="cohort"
            [searchEnabled]="true" [searchExpr]="['program']" [(ngModel)]="cohortId"
            (onValueChanged)="cohortOptionChange($event)">
            <dx-validator validationGroup="validationGrp">
              <dxi-validation-rule type="required" message="Programme Name Required"></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
      </div>
      <div class="center" style="margin-top: 4%;">
        <dx-button class="themeButton" text="Submit" (onClick)="onFormSubmit($event)"
          [useSubmitBehavior]="true"></dx-button>
      </div>
    </div>
  </div>
</div>
